import * as actionTypes from "./types";

const INITIAL_STATE = {
  pageData: {},
  loading: false,
  success: false,
  error: false,
  showSideBar: true,
  isNewAppraisal: false,
  actionChatID: "",
};

const pageReducer = (state = INITIAL_STATE, action) => {
  const { payload } = action;
  switch (action.type) {
    case actionTypes.REQUEST_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.ADD_CHAT_ID:
      return {
        ...state,
        actionChatID: payload,
      };
    case actionTypes.LOADING_FALSE:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.REQUEST_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
      };

    case actionTypes.REQUEST_FAILED:
      return {
        ...state,
        error: false,
        loading: false,
      };
    case actionTypes.CURRENT_PAGE_SUCCESS:
      return {
        ...state,
        pageData: { ...state.pageData, ...payload },
        loading: false,
        success: true,
      };
    case actionTypes.SHOW_SIDEBAR_ON_CURRENT_PAGE:
      return {
        ...state,
        showSideBar: true,
      };

    case actionTypes.UPDATE_CHAT:
      const updatedChats = state?.pageData?.appraisalChats?.map((chat) =>
        chat?._id === payload?._id ? payload : chat
      );
      return {
        ...state,
        pageData: {
          ...state.pageData,
          appraisalChats: updatedChats,
        },
      };
    case actionTypes.DO_NOT_SHOW_SIDEBAR_ON_CURRENT_PAGE:
      return {
        ...state,
        showSideBar: false,
      };
    case actionTypes.NEW_APPRAISAL:
      return {
        ...state,
        isNewAppraisal: true,
      };
    case actionTypes.OLD_APPRAIASAL:
      return {
        ...state,
        isNewAppraisal: false,
      };
    case actionTypes.CURRENT_TAB:
      return {
        ...state,
        pageData: { ...state.pageData, ...payload },
      };
    case actionTypes.REMOVE_APPRAISALS_DETAILS:
      return {
        ...state,
        pageData: {
          ...state.pageData,
          appraisalDetail: null,
        },
      };
    case actionTypes.UPDATE_APPRAISAL_STATUS:
      return {
        ...state,
        pageData: {
          ...state.pageData,
          appraisalDetail: {
            ...state?.pageData?.appraisalDetail,
            status: payload,
          },
        },
      };
    default:
      return state;
  }
};

export default pageReducer;
